import styled from "styled-components";

export const Title = styled.h1`
  color: #000;
  font-size: 2.2rem;
  padding-bottom: 2rem;
`;
